<div class="flex flex-col gap-1.5" [class]="containerClass()">
  <label class="checklist-task-label label" [attr.for]="id()">
    {{ label() }}
  </label>

  <output
    class="text-sm font-normal text-primary leading-6 whitespace-pre-line"
    [class]="textClass()"
    [attr.id]="id()"
    role="note">
    {{ displayText }}
  </output>
</div>
